import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.group_id = parseInt(payload.group_id, 10)
}

var state = {
  rentsoftSettings: []
}

var getters = {
  RENTSOFT_SETTINGS: (state) => {
    return state.rentsoftSettings
  }
}

var mutations = {
  SET_RENTSOFT_SETTINGS: (state, payload) => {
    state.rentsoftSettings = payload
  }
}

var actions = {
  GET_RENTSOFT_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/rentsoft')
    if (result.status === 200) {
      context.commit('SET_RENTSOFT_SETTINGS', result.data)
    }
  },
  CREATE_RENTSOFT_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/rentsoft', payload)
  },
  UPDATE_RENTSOFT_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/rentsoft', payload)
  },
  DELETE_RENTSOFT_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/rentsoft?rentsoft_setting_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/rentsoft.js